/**
 * @generated SignedSource<<1760cc4660fec76dfcdcbf0ca6ddfcda>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditorialModuleArticles_articles$data = ReadonlyArray<{
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"ArticleLink_article">;
  readonly " $fragmentType": "EditorialModuleArticles_articles";
}>;
export type EditorialModuleArticles_articles$key = ReadonlyArray<{
  readonly " $data"?: EditorialModuleArticles_articles$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditorialModuleArticles_articles">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "EditorialModuleArticles_articles",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ArticleLink_article"
    }
  ],
  "type": "WordpressArticleType",
  "abstractKey": null
};

(node as any).hash = "1c784ff618357fdea88126e68ff37d8e";

export default node;
